import instagramIcon from '../../../../Icons/icon-instagram.svg';
import facebookIcon from '../../../../Icons/icon-facebook.svg';
import twitterIcon from '../../../../Icons/icon-twitter.svg';
import linkedinIcon from '../../../../Icons/icon-linkedin.svg';
import mailIcon from '../../../../Icons/icon-mail.svg';

export const cardObj = [
  {
    index: 1,
    title: 'Classy Metal Card',
    subtitle: '— Free for a lifetime',
    features: [
      'Stand out with a full metal card',
      'No added fees',
      'Truly free forever',
    ],
    image:
      'https://www.getonecard.app/assets/apply/classy_metalcard_4x_min.webp',
  },
  {
    index: 2,

    title: 'One Click',
    subtitle: 'Full Control',
    features: [
      'Track all your spends easily',
      'Card lost? Block it instantly',
      'Swipe to Pay, no OTPs',
    ],
    image:
      'https://www.getonecard.app/assets/apply/one_click_4x_min.webp',
  },
  {
    index: 3,

    title: '5x Rewards',
    subtitle: 'Instantly credited to account',
    features: [
      'Rewards on your spends',
      'Instant redemption',
      'Points never expire. Never.',
    ],
    image:
      'https://www.getonecard.app/assets/apply/classy_metalcard_4x_min.webp',
  },

  {
    index: 4,
    title: 'Quick Onboarding',
    subtitle: 'No Joining Fees',
    features: [
      'Activate card in 5 minutes',
      'Fully digital',
      'Spam-free process',
    ],
    image:
      'https://www.getonecard.app/assets/apply/quick_onbaording4x_min.webp',
  },

  {
    index: 5,
    title: 'Easy EMIs',
    subtitle: 'Zero Documentation',
    features: [
      'Convert spends into EMIs in a single click',
      'Pay back at your convenience',
      'Choose a tenure of your choice',
    ],
    image: 'https://www.getonecard.app/assets/apply/EMIs_4xmin.webp',
  },
];
export const faqObjects = [
  {
    question: 'What is OneCard?',
    answer:
      'OneCard is an internationally valid Visa Signature credit card, managed by FPL Technologies Pvt. Ltd. It’s a metal credit card that also works as a virtual credit card.',
  },
  {
    question: 'How can I check my approved card limit for OneCard?',
    answer:
      'Register your details on the OneCard app. Post CIBIL verification, you can see your approved card limit immediately. This takes less than 5 minutes.',
  },
  {
    question:
      'Are there any charges like annual fees or hidden costs?',
    answer:
      'Nope! We believe in full transparency. OneCard is a Lifetime Free Credit Card. Any other charges like late payment fees, interest on unpaid dues, etc. are mentioned clearly on the app.',
  },
  {
    question: 'How to apply for OneCard? ',
    answer:
      'Download the OneCard app from play store or app store and fill out the application form. Your virtual credit card will get activated instantly and your metal card will arrive in the next 3-5 working days.',
  },
];
export const socialMediaObjects = [
  {
    icon: instagramIcon,
    url: 'https://www.instagram.com/',
  },
  {
    icon: facebookIcon,
    url: 'https://www.facebook.com/GetOneCardIN/',
  },
  {
    icon: twitterIcon,
    url: 'https://twitter.com/GetOneCardIN',
  },
  {
    icon: linkedinIcon,
    url: 'https://in.linkedin.com/showcase/onecard-app/',
  },
  { icon: mailIcon, url: 'help@getonecard.app' },
];

export const bankMarqueeImageArray = [
  {
    image: 'https://www.getonecard.app/assets/apply/BOB_4x.png',
    id: 1,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/CSB_4x.png',
    id: 2,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/SBM_4x.webp',
    id: 3,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/SIB_4x.png',
    id: 4,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/FB_4x.png',
    id: 5,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/BOB_4x.png',
    id: 6,
  },
  {
    image: 'https://www.getonecard.app/assets/apply/CSB_4x.png',
    id: 7,
  },
];
